/*
 * FOC-57 · Idioma del checkout desde el carrito.
 *
 * PickEasy (Order Delivery Date & Time, slots-script-tag.js) reescribe el action de los formularios
 * del carrito para mandar al checkout de retiro (?step=contact_information&method=pickup&…) y le
 * agrega &locale=en-CA cuando su opción «Store pickup checkout text changes» no tiene textos en
 * español. Esa opción no aparece ni en el panel de la app ni en el embed del tema, así que el checkout
 * salía en inglés (/checkouts/…/en-ca) aunque la tienda esté en español.
 *
 * Este script cambia ese locale por el de la tienda (data-locale, por ejemplo «es-AR») en el último
 * momento posible, sin tocar nada más del flujo de PickEasy (día, franja y su validación):
 * - en el evento submit, en captura: el navegador lee el action recién después de ese evento;
 * - cuando cambia el action o el formaction de un formulario o botón (por si PickEasy lo vuelve a
 *   escribir o usa form.submit(), que no dispara submit);
 * - en los campos ocultos name="locale", por si los agrega.
 * Solo toca formularios y botones que van al carrito o al checkout.
 */
(function (root) {
  'use strict';

  /** Rutas que llevan al checkout: el carrito (POST con name="checkout") y el checkout directo. */
  var CHECKOUT_PATH = /^\/(cart|checkout)(\/|$)/;

  /**
   * Devuelve la URL con el parámetro locale cambiado por el de la tienda. Si la URL no va al carrito
   * o al checkout, o no tiene locale, la devuelve igual.
   * @param {string | null} url
   * @param {string} locale
   * @param {string} base - origen para resolver URLs relativas
   * @returns {string | null}
   */
  function withStoreLocale(url, locale, base) {
    if (!url || !locale) return url;
    var parsed;
    try {
      parsed = new URL(url, base);
    } catch (error) {
      return url;
    }
    if (!CHECKOUT_PATH.test(parsed.pathname)) return url;
    var current = parsed.searchParams.get('locale');
    if (current === null || current.toLowerCase() === locale.toLowerCase()) return url;
    parsed.searchParams.set('locale', locale);
    // Si era relativa, se mantiene relativa.
    return /^[a-z][a-z0-9+.-]*:/i.test(url) ? parsed.toString() : parsed.pathname + parsed.search + parsed.hash;
  }

  /**
   * Corrige el action del formulario, el formaction del botón que lo envía y un campo locale.
   * @param {HTMLFormElement | null} form
   * @param {string} locale
   * @param {string} base
   * @param {Element | null} [submitter]
   * @returns {boolean} true si cambió algo
   */
  function fixForm(form, locale, base, submitter) {
    var changed = false;
    if (form && form.getAttribute) {
      var action = form.getAttribute('action');
      var fixed = withStoreLocale(action, locale, base);
      if (fixed !== action) {
        form.setAttribute('action', fixed);
        changed = true;
      }
      var field = form.elements && form.elements.namedItem ? form.elements.namedItem('locale') : null;
      if (field && 'value' in field && field.value && field.value.toLowerCase() !== locale.toLowerCase()) {
        var target = (form.getAttribute('action') || '').split('?')[0];
        if (CHECKOUT_PATH.test(new URL(target || '/cart', base).pathname)) {
          field.value = locale;
          changed = true;
        }
      }
    }
    if (submitter && submitter.getAttribute) {
      var formaction = submitter.getAttribute('formaction');
      var fixedFormaction = withStoreLocale(formaction, locale, base);
      if (fixedFormaction !== formaction) {
        submitter.setAttribute('formaction', fixedFormaction);
        changed = true;
      }
    }
    return changed;
  }

  /**
   * Conecta el arreglo al documento.
   * @param {Document} doc
   * @param {string} locale
   */
  function init(doc, locale) {
    if (!doc || !locale) return;
    var base = doc.location ? doc.location.href : 'https://localhost/';

    /** @returns {number} cuántos formularios o botones cambió */
    function fixAll() {
      var changed = 0;
      var forms = doc.forms || [];
      for (var i = 0; i < forms.length; i++) if (fixForm(forms[i], locale, base, null)) changed++;
      var buttons = doc.querySelectorAll ? doc.querySelectorAll('[formaction]') : [];
      for (var j = 0; j < buttons.length; j++) if (fixForm(null, locale, base, buttons[j])) changed++;
      return changed;
    }

    // Último momento: el navegador arma el envío con el action que quede después de este evento.
    doc.addEventListener(
      'submit',
      function (event) {
        fixForm(event.target, locale, base, event.submitter || null);
      },
      true
    );

    // Si PickEasy reescribe el action más tarde (o envía con form.submit()), se corrige al instante.
    // El tope evita un ida y vuelta infinito si alguien más lo vuelve a escribir en cada cambio.
    if (typeof MutationObserver === 'function') {
      var fixes = 0;
      var observer = new MutationObserver(function () {
        if (fixes > 200) {
          observer.disconnect();
          return;
        }
        fixes += fixAll();
      });
      observer.observe(doc.documentElement, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['action', 'formaction', 'value'],
      });
    }

    fixAll();
  }

  root.FocCheckoutLocale = { withStoreLocale: withStoreLocale, fixForm: fixForm, init: init };

  if (typeof document !== 'undefined' && document.currentScript && !root.focCheckoutLocaleReady) {
    root.focCheckoutLocaleReady = true;
    init(document, document.currentScript.dataset.locale || '');
  }
})(typeof window !== 'undefined' ? window : globalThis);
